import queryString from 'query-string';
import { useLocation } from '@reach/router';

import { useNav } from '@lib/hooks';
import { useEffect } from 'react';

export const useSetEntityNavPage = () => {
  const location = useLocation();
  const { setPage } = useNav();

  const { r: roomSlug } = queryString.parse(location.search);

  useEffect(() => {
    setPage(roomSlug ?? 'library');
  }, [roomSlug]);
};
